import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {interval} from 'rxjs';
import {PostmethodService} from 'src/app/app-config/postmethod.service';
import {OrderNOtificationService} from './order-notification.service';
import {ResponseModel} from 'src/app/models/ResponseModel';
import {EncryptDecryptResponse} from 'src/app/models/response/EncryAndDecryResponse';
import {EncryptdecryptService} from 'src/app/auth/encryptdecrpt.service';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-order-notification',
  templateUrl: './order-notification.component.html',
  styleUrls: ['./order-notification.component.css'],
})
export class OrderNotificationComponent implements OnInit {
  responseModel: ResponseModel = new ResponseModel();
  modalRef?: BsModalRef;
  @ViewChild('rosterCreate_pop') rosterCreateTemplate: TemplateRef<any>;
  encrydecryresponse: EncryptDecryptResponse = new EncryptDecryptResponse();
  audio: HTMLAudioElement = new Audio();
  isShowModal: any = false;

  constructor(
    private modalService: BsModalService,
    private serviceMethod: PostmethodService,
    private service: OrderNOtificationService,
    private router: Router,
    private encryptDecrypt: EncryptdecryptService,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    interval(30000).subscribe(() => {
      this.getAppOrderNotification();
    });
  }

  create_Roster_Modal = {
    backdrop: true,
    ignoreBackdropClick: true,
    class: 'modal-md modal-dialog-centered',
  };

  closeModal(modalId1?: number) {
    this.modalService.hide(modalId1);
    this.audio.pause();
  }

  playAudio(audioPath: any): void {
    try {
      this.audio.src = audioPath;
      this.audio.load();
      this.audio.play();
    } catch (error) {
      console.error('Error playing audio:', error);
    }
  }

  handleViewOrderClick() {
    this.modalService.hide();
    const currentRoute = this.router.url;
    if (currentRoute === '/weClean/order/orderStatus') {
      window.location.reload();
    } else {
      this.router.navigate(['/weClean/order/orderStatus']);
    }
    this.audio.pause();
  }

  getAppOrderNotification() {
    this.service.getAppOrderNotification().subscribe((response: any) => {
      this.responseModel = new ResponseModel();
      this.responseModel = response.body;
      let clientSecret = response.headers.get('clientsecret');
      if (this.responseModel.statusCode == 200) {
        this.encrydecryresponse = this.encryptDecrypt.decryption(
          this.responseModel.responseData,
          clientSecret,
        );
        this.responseModel.responseObject = this.encrydecryresponse.data;
        console.log(this.responseModel.responseObject);
        const orderCount =
          this.encrydecryresponse.data.responseObject.object
            .getAppOrderNotification[0]['ORDER COUNT'];
        const messageCount =
          this.encrydecryresponse.data.responseObject.object
            .getAppOrderNotification[0]['NEW MESSAGE COUNT'];
        const approvalCount =
          this.encrydecryresponse.data.responseObject.object
            .getAppOrderNotification[0]['APPROVAL COUNT'];
        const raisedCsCount =
          this.encrydecryresponse.data.responseObject.object
            .getAppOrderNotification[0]['RAISED CS COUNT'];

        const localOrderCount = localStorage.getItem('todaysOrderCount');
        const localMessageCount = localStorage.getItem(
          'todayslocalMessageCount',
        );
        const localApprovalCount = localStorage.getItem(
          'todayslocalApprovalCount',
        );
        const localRaisedCsCount = localStorage.getItem(
          'todayslocalRaisedCsCount',
        );
        if (orderCount > 0) {
          if (localOrderCount != orderCount) {
            localStorage.setItem('todaysOrderCount', orderCount);
            this.isShowModal = true;
            if (this.rosterCreateTemplate) {
              this.modalRef = this.modalService.show(
                this.rosterCreateTemplate,
                this.create_Roster_Modal,
              );
            }
            this.playAudio('/assets/notification-sound/orderNotification.mp3');
          } else {
            this.isShowModal = false;
            localStorage.setItem('todaysOrderCount', orderCount);
          }
        }

        if (messageCount > 0) {
          if (localMessageCount != messageCount) {
            let toast = this.toastr.success('New Message', '', {
              disableTimeOut: true,
              positionClass: 'toast-top-right',
            });
            toast.onTap.subscribe(action => {
              this.router.navigate(['/weClean/message']);
            });
            localStorage.setItem('todayslocalMessageCount', messageCount);
            this.playAudio('/assets/notification-sound/newMessage.mp3');
          } else {
            localStorage.setItem('todayslocalMessageCount', messageCount);
          }
        }

        if (raisedCsCount > 0) {
          if (localRaisedCsCount != raisedCsCount) {
            let toast = this.toastr.success('New CS Raised', '', {
              disableTimeOut: true,
              positionClass: 'toast-top-right',
            });
            toast.onTap.subscribe(action => {
              this.router.navigate(['/weClean/riders/reschedule-order']);
              this.audio.pause();
            });
            localStorage.setItem('todayslocalRaisedCsCount', raisedCsCount);
            this.playAudio('/assets/notification-sound/newMessage.mp3');
          } else {
            localStorage.setItem('todayslocalRaisedCsCount', raisedCsCount);
          }
        }

        if (approvalCount > 0) {
          if (localApprovalCount != approvalCount) {
            let toast = this.toastr.success('New Approval', '', {
              timeOut: 8000,
              positionClass: 'toast-top-right',
            });
            toast.onTap.subscribe(action => {
              this.router.navigate(['/weClean/order/approvals']);
            });
            localStorage.setItem('todayslocalApprovalCount', approvalCount);
            this.playAudio('/assets/notification-sound/approval.mp3');
          } else {
            localStorage.setItem('todayslocalApprovalCount', approvalCount);
          }
        }
      }
    });
  }
}
